import React from 'react';
import UISearchSection, { SearchData } from '@/components/shared/UISearchSection';
import { UISelectOption } from '@/components/shared/UISelect';
import './PropertySearchSection.scss';

export interface PropertySearchSectionProps {
  /**
   * Поточне значення пошуку
   */
  searchValue?: string;

  /**
   * Поточне значення фільтра
   */
  filterValue?: string;

  /**
   * Обробник пошуку
   */
  onSearch?: (searchData: SearchData) => void;

  /**
   * Обробник зміни фільтра
   */
  onFilterChange?: (value: string) => void;

  /**
   * Обробник зміни тексту пошуку
   */
  onSearchChange?: (value: string) => void;

  /**
   * Обробник очищення пошуку
   */
  onClear?: () => void;

  /**
   * Стан завантаження
   */
  loading?: boolean;

  /**
   * Додатковий CSS клас
   */
  className?: string;

  /**
   * Варіант відображення
   */
  variant?: 'inline' | 'wrapped';

  /**
   * Опції фільтра (якщо не передані, використовуються мокові)
   */
  filterOptions?: UISelectOption[];
}

// Мокові опції фільтра згідно з дизайном
const mockFilterOptions: UISelectOption[] = [
  { value: 'all', label: 'All' },
  { value: 'leased', label: 'Leased' },
  { value: 'vacant', label: 'Vacant' },
  { value: 'available', label: 'Available' }
];

const baseClass = 'PropertySearchSection';

const PropertySearchSection: React.FC<PropertySearchSectionProps> = ({
                                                                       searchValue = '',
                                                                       filterValue = 'all',
                                                                       onSearch,
                                                                       onFilterChange,
                                                                       onSearchChange,
                                                                       onClear,
                                                                       loading = false,
                                                                       className = '',
                                                                       variant = 'wrapped',
                                                                       filterOptions = mockFilterOptions,
                                                                     }) => {
  const handleSearch = (searchData: SearchData) => {
    if (onSearch) {
      onSearch(searchData);
    } else {
      // Мокова функція для демонстрації
      console.log('Property search:', searchData);
    }
  };

  const handleFilterChange = (value: string) => {
    if (onFilterChange) {
      onFilterChange(value);
    }
  };

  const handleSearchChange = (value: string) => {
    if (onSearchChange) {
      onSearchChange(value);
    }
  };

  const handleClear = () => {
    if (onClear) {
      onClear();
    }
  };

  return (
    <div className={`${baseClass} ${className}`.trim()}>
      <UISearchSection
        selectOptions={filterOptions}
        selectPlaceholder="Select Option"
        selectValue={filterValue}
        selectWidth="160px"
        inputPlaceholder="Search units, tenants..."
        inputValue={searchValue}
        onSearch={handleSearch}
        onSelectChange={handleFilterChange}
        onInputChange={handleSearchChange}
        onClear={handleClear}
        searchButtonText="Search"
        searchOnSelectChange={true}
        searchOnEnter={true}
        loading={loading}
        spacing="default"
        variant={variant}
        className={`${baseClass}__search`}
      />
    </div>
  );
};

export default PropertySearchSection;